<script>
    import { onMount } from 'svelte';
    import { goto, url, isActive } from '@roxi/routify';
    import { postFormData, getData, isLoggedIn } from '../helpers.js';
    import { activeTabs, subscriptionType, featuresLoaded, loadFeatures } from '../stores/integrations.js';
    import { username, accountValid, lifetimeValid, accountValidityError, periodDownloads, loadUserInfo } from '../stores/userInfo.js';

    loadFeatures();
    loadUserInfo();
    // import Icon from 'svelte-awesome';
    // import { bars } from 'svelte-awesome/icons';
    
    let mobile_extended = false;
    let account_menu_open = false;
    let gpuStatus = 'stopped'; // 'running', 'stopped'

    //protected route, check if logged in
	onMount(async () => {
		isLoggedIn().then((res) => {
			if(res) {
			// do nothing (logged in)
			} else {
				$goto('./login');
			};
		}).catch(() => {
			// assume not logged in if there's an error.
			$goto('./login');
		});

        // Start GPU status polling
        checkGpuVmStatus();
        setInterval(checkGpuVmStatus, 30000); // Check every 30 seconds
	});

    async function checkGpuVmStatus() {
        try {
            const res = await fetch('/api/v1/util/gpu-vm-status');
            const data = await res.json();
            gpuStatus = data.status === 'running' ? 'running' : 'stopped';
        } catch (e) {
            gpuStatus = 'stopped';
        }
    }

    function handleLogout() {
        let res = getData('logout');
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				$goto('/');
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				console.log(errors);
                browser.cookies.remove({
                    url: document.location.hostname,
                    name: "session",
                });
                $goto('/')
			}
		});
    }

    // Link entries: [path, name, admin]. admin: true gets the muted styling.
    // (Dashboard lives on the logo; Logout lives in the account dropdown)
    // Left group: Integrations + entitled integration tabs.
    $: leftLinks = [
        ['./integrations', 'Integrations', true],
        ...$activeTabs.map(t => [t.path, t.name, false]),
        //['./wage-report-test', 'Theft - Test'],
        //['./test', 'db TEST'],
        //['./agenda', 'Agency Agendas'],
        //['./agenda-settings', 'A.Agenda Settings'],
    ];
    // Right group: admin tabs pushed to the far right on desktop.
    const rightLinks = [
        ['./history', 'History', true],
        ['./faq', 'FAQs', true]
    ];
    $: links = [...leftLinks, ...rightLinks]; // mobile keeps the combined order

    function extendMobileNavbar() {
        mobile_extended = !mobile_extended;
        if (mobile_extended) {
            document.getElementById('navbar').parentElement.style.overflowY = 'hidden';
            document.getElementById('navbar').parentElement.style.position = 'fixed';
        } else {
            document.getElementById('navbar').parentElement.style.overflowY = 'auto';
            document.getElementById('navbar').parentElement.style.position = 'unset';
        }
    }

    // Close the account dropdown on click-outside or Escape
    function handleWindowClick(event) {
        if (account_menu_open && !event.target.closest('#account-menu')) {
            account_menu_open = false;
        }
    }
    function handleWindowKeydown(event) {
        if (event.key === 'Escape') {
            account_menu_open = false;
        }
    }
</script>

<svelte:window on:click={handleWindowClick} on:keydown={handleWindowKeydown}/>

<!--Hacky method to switch between mobile and desktop
    There's probably a better way to implement in Svelte
    But this method works.
    TODO: FIX INTO SVELTE METHOD RATHER THAN TAILWIND BREAKPOINTS
-->
<div id='navbar' class="lg:sticky lg:top-0 lg:z-[125]">

    <!--MOBILE-->
    <div class="relative w-full lg:hidden mb-5 bg-gray-100 shadow-md">

        <div class="w-max mx-auto">    
            <a href="/dashboard">
                <div class="w-max px-5 pt-4 pb-2 text-center text-2xl font-bold font-mono">
                    <img class="logo h-8" src="./ref/padg_lockup_invert.svg" alt="Palo Alto Data Group Logo">
                    <p class="text-xs font-sans font-semibold text-gray-600 mt-1">Dashboard</p>
                </div>
            </a>
        </div>
        
        <!-- From svelte-awesome; but the library takes too long to compile. -->
        <div class="absolute z-[120] top-5 left-5" on:click={extendMobileNavbar}>
            <svg version="1.1" class="inline-block" width="27.428571428571427" height="32" role="presentation" viewBox="0 0 1536 1792" style="font-size: 2em; fill:currentColor">
                <path id="path-0" d="M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"></path>
            </svg>
            <!-- <Icon data={bars} scale="2"/> -->
        </div>
        {#if mobile_extended}
            <div id="grey-out" class="absolute top-0 left-0 h-screen w-screen opacity-30 bg-black z-[100]"
                on:click={extendMobileNavbar}>
            </div>
            <div class="absolute top-0 left-0 pt-10 h-screen overflow-y-auto bg-gray-50 z-[110]">
                <nav class="flex flex-col mt-8 ml-auto">
                    <a href="/dashboard">
                        <button class="navbutton border-r-0 h-full w-full 
                            {$isActive('./dashboard') ? 'current-tab' : ''}">
                            <div class="w-auto h-full px-4">
                                Dashboard
                            </div>
                        </button>
                    </a>
                    {#if !$featuresLoaded}
                        <div class="px-4 py-3 text-gray-400 text-sm">Loading tabs...</div>
                    {/if}
                    {#each links as [path, name, admin]}
                        <a href={$url(path)}>
                            <button class="navbutton border-r-0 h-full w-full 
                                {$isActive(path) ? 'current-tab' : (admin ? 'admin-tab' : '')}">
                                <div class="w-auto h-full px-4">
                                    {name}
                                </div>
                            </button>
                        </a>
                    {/each}

                    <button class="navbutton border-r-0 w-full" on:click={() => handleLogout()}>
                        <div class="w-auto h-full px-4">
                            Logout
                        </div>
                    </button>
                </nav>
            </div>
        {/if}
    </div>
    
    <!--DASHBOARD-->
    <div class="hidden lg:flex mb-5 bg-gray-100 shadow-md">
        <div id="account-menu" class="relative flex items-center">
            <a href="/dashboard">
                <div class="py-3 px-5 text-left text-2xl font-bold font-mono">
                    <img class="logo h-8" src="./ref/padg_lockup_invert.svg" alt="Palo Alto Data Group Logo">
                    <p class="text-xs font-sans font-semibold text-gray-600 mt-1">Dashboard</p>
                </div>
            </a>
            <button class="mr-2 px-2 py-1 rounded-md text-gray-600 hover:bg-gray-200 border-none bg-transparent cursor-pointer"
                aria-haspopup="true" aria-expanded={account_menu_open} aria-label="Account menu"
                on:click={() => account_menu_open = !account_menu_open}>
                <svg width="32" height="32" viewBox="0 0 24 24" fill="currentColor" class="{account_menu_open ? 'rotate-180' : ''} transition-transform">
                    <path d="M7 10l5 5 5-5z"/>
                </svg>
            </button>
            {#if account_menu_open}
                <div class="absolute left-2 top-full z-[130] w-72 bg-white rounded-md shadow-lg border border-gray-200 py-2">
                    <div class="px-4 py-2 text-gray-800">
                        <p class="font-semibold text-lg">{$username ? 'Hi ' + $username : ''}</p>
                        <p class="text-sm {$subscriptionType ? '' : 'hidden'}">Subscription Type: {$subscriptionType}</p>
                        <p class="text-sm">Account Status: {$accountValid ? 'Valid' : 'Invalid'}</p>
                        {#if $accountValidityError}
                            <p class="text-sm text-red-500">{$accountValidityError}</p>
                        {/if}
                        {#if $accountValid && $subscriptionType === 'NONE'}
                            <p class="text-sm">Subscription cancelling at the end of this period.</p>
                        {/if}
                        {#if $lifetimeValid}
                            <p class="text-sm">You have an enterprise account.</p>
                        {/if}
                        {#if $periodDownloads !== null}
                            <p class="text-sm">{$periodDownloads} {$periodDownloads == 1 ? 'file' : 'files'} downloaded this period</p>
                        {/if}
                    </div>
                    <hr class="border-gray-200 my-1">
                    <a href="/dashboard" class="block px-4 py-2 text-gray-800 hover:bg-gray-100">
                        Dashboard
                    </a>
                    <a href="/integrations" class="block px-4 py-2 text-gray-800 hover:bg-gray-100">
                        Manage Integrations
                    </a>
                    <a href="/user-info-menu" class="block px-4 py-2 text-gray-800 hover:bg-gray-100">
                        Edit Information
                    </a>
                    <button class="block w-full text-left px-4 py-2 text-gray-800 hover:bg-gray-100 border-none bg-transparent cursor-pointer"
                        on:click={() => handleLogout()}>
                        Logout
                    </button>
                </div>
            {/if}
        </div>
        <nav class="flex grow">
            {#each leftLinks as [path, name, admin]}
                <a href={$url(path)}>
                    <button class="navbutton border-r-0 h-full w-full 
                        {$isActive(path) ? 'current-tab' : (admin ? 'admin-tab' : '')}">
                        <div class="w-auto h-full px-4">
                        <div class="w-auto h-full">
                            {name}
                        </div>
                    </button>
                </a>
            {/each}
            {#if !$featuresLoaded}
                <!-- Same guard as the mobile menu: entitled tabs appear once
                     user/paywall-features resolves, so mark the gap instead of
                     flashing a freemium-only strip. -->
                <div class="self-center px-4 text-gray-400 text-sm">Loading tabs...</div>
            {/if}
            <div class="ml-auto flex">
                {#each rightLinks as [path, name, admin]}
                    <a href={$url(path)}>
                        <button class="navbutton border-r-0 h-full w-full 
                            {$isActive(path) ? 'current-tab' : (admin ? 'admin-tab' : '')}">
                            <div class="w-auto h-full px-4">
                            <div class="w-auto h-full">
                                {name}
                            </div>
                        </button>
                    </a>
                {/each}
            </div>
        </nav>
    </div>
</div>

<style>
    .navbutton {
        @apply py-5 px-5 rounded-none text-gray-800;
    }
    .navbutton:hover {
        @apply bg-gray-200;
    }
    /* Muted look for admin tabs (Integrations, History, FAQs); the class is
       only applied when the tab is not the current page. */
    .navbutton.admin-tab {
        @apply text-gray-500;
    }
    .navbutton.current-tab {
        @apply bg-gray-600 text-gray-200 border-0;
    }
    .navbutton.current-tab:hover {
        @apply bg-gray-600;
    }
    .gpu-dot {
        width: 10px;
        height: 10px;
        border-radius: 50%;
        background-color: #999;
    }
    .gpu-dot.running {
        background-color: #4caf50;
    }
    .gpu-dot.stopped {
        background-color: #fbbf24;
    }

</style>
